import { render, staticRenderFns } from "./ProFeatureModal.vue?vue&type=template&id=2e13987a&scoped=true&"
import script from "./ProFeatureModal.vue?vue&type=script&lang=js&"
export * from "./ProFeatureModal.vue?vue&type=script&lang=js&"
import style0 from "./ProFeatureModal.vue?vue&type=style&index=0&id=2e13987a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e13987a",
  null
  
)

export default component.exports